import React, { useContext, Fragment, useEffect } from "react";
import { SeguradoraContext } from "../SeguradoraContext";
import Pesquisar from "../../../../../Components/Cadastro/Pesquisar/Pesquisar";
import TabelaResultados from "../../../../../Components/Cadastro/TabelaResultados/TabelaResultados";

const PesquisarSeguradora = () => {
  const { values, setValues, resetScreen } = useContext(SeguradoraContext);

  useEffect(() => {
    resetScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onChangeInput(event) {
    const { name, value } = event.target;
    setValues({
      ...values,
      searchData: {
        ...values.searchData,
        [name]: value,
      },
    });
  }

  return (
    <Fragment>
      <Pesquisar context={SeguradoraContext}>

        <div className="col-12 col-md-4">
          <label>Nome da Seguradora</label>
          <input
            className="form-control"
            type="text"
            name="seguradoraDescricao"
            value={values.searchData.seguradoraDescricao}
            onChange={onChangeInput}
          />
        </div>
      </Pesquisar>
      <TabelaResultados context={SeguradoraContext} />
    </Fragment>
  );
};

export default PesquisarSeguradora;
